// FILE: SystemNoticeRow.logic.ts
// Purpose: Shape a server-authored notice for the transcript row that shows it.
// Exports: presentation helper for SystemNoticeRow.

/**
 * Prefix the server puts on a notice so the *agent* — which only ever sees text
 * — knows the turn did not come from the user. The row says the same thing
 * visually, so it is stripped before display instead of repeating it.
 */
const SYSTEM_NOTICE_PREFIX = "[sistema]";

export interface SystemNoticePresentation {
  /** First line, the one the collapsed row shows. */
  headline: string;
  /** Everything after it, if there is anything worth expanding. */
  details: string | null;
}

export function describeSystemNotice(text: string): SystemNoticePresentation {
  const withoutPrefix = text.trimStart().startsWith(SYSTEM_NOTICE_PREFIX)
    ? text.trimStart().slice(SYSTEM_NOTICE_PREFIX.length)
    : text;
  const lines = withoutPrefix.trim().split("\n");
  const headline = (lines[0] ?? "").trim();
  const details = lines.slice(1).join("\n").trim();
  return {
    headline: headline.length > 0 ? headline : "Aviso del sistema",
    details: details.length > 0 ? details : null,
  };
}
